import { PlansList } from '@/components/subscription/PlansList';
import { useBillingPortal } from '@/hooks/use-billing-portal';

type BillingPlansModalProps = {
    activePlanName?: string | null;
    nextPaymentDate?: string | number | null;
};

export default function BillingPlansModal({
    activePlanName,
    nextPaymentDate,
}: BillingPlansModalProps) {
    const { isPortalLoading, openBillingPortal } = useBillingPortal();

    return (
        <PlansList
            activePlanName={activePlanName}
            compact
            nextPaymentDate={nextPaymentDate}
            onManageSubscription={openBillingPortal}
            isManageLoading={isPortalLoading}
        />
    );
}
